import type { FIXED_INDENTS } from 'vars/index'

import { styled } from '@linaria/react'

export const PopupHeaderCroppedTemplateSC = styled.div<{
  verticalPaddings?: FIXED_INDENTS[]
}>`
  padding-top: ${({ verticalPaddings }) =>
    verticalPaddings?.[0] ? `var(${verticalPaddings[0]})` : `0`};
  padding-bottom: ${({ verticalPaddings }) =>
    verticalPaddings?.[1]
      ? `var(${verticalPaddings[1]})`
      : verticalPaddings?.[0]
        ? `var(${verticalPaddings[0]})`
        : `0`};
`
